import { render, staticRenderFns } from "./id-card.vue?vue&type=template&id=70686198&scoped=true"
import script from "./id-card.vue?vue&type=script&lang=js"
export * from "./id-card.vue?vue&type=script&lang=js"
import style0 from "./id-card.vue?vue&type=style&index=0&id=70686198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70686198",
  null
  
)

export default component.exports